<template>
  <div class="home">
<div class="works">
	<div class="works-ban">
		<h2>Contact us</h2>
		<p>HOME / CONTACT US</p>
	
	</div>
	<div class="home-ct">
<div class="contact">
	<div class="con-buff">
		<div class="tit">
			ABOUT US
		</div>
		<div class="con">
			FuelMe is a car model & fashion brand, we hope show the charm of Chinese made car model to the world through our fine craft. By miniature car model, we aim to pursue amazing stories,  interesting culture and great dream to all over the world.
		</div>
	</div>
	<el-row :gutter="40">
		<el-col :span="10">
			<div class="con-buff">
				<div class="tit">
					Work with us 
				</div>
				<div class="con">
					FuelMe, as a car model& fashion brand, do not reject any mode of cooperation and we are delight to take any offer from you. Please send us your ideas of cooperation by email. Info@fuelme.com.cn
				</div>
			</div>
			<div class="con-buff">
				
				<div class="tit">
					Contact us
				</div>
				<div class="con">
					We have great interest to communicate with all of you. We are glad to hear your story, your car and your life.  If you want to share any of these, feel free to contact us by sending email to info@fuelme.com.cn
				</div>
			</div>
		</el-col>
		<el-col :span="14">
			
			
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"  label-position="top" class="han-tab" size="mini">
				<el-row :gutter="20">
					 <el-col :span="12">
			  <el-form-item label="Your Name" prop="name">
			    <el-input v-model="ruleForm.name"></el-input>
			  </el-form-item>
			  </el-col>
			  <el-col :span="12">
			  <el-form-item label="Your Email" prop="email">
			    <el-input v-model="ruleForm.email"></el-input>
			  </el-form-item>
			  </el-col>
			 </el-row>
			 
			
			 
			 <el-row :gutter="20">
			 			 <el-col :span="12">
			  <el-form-item label="Phone Number" prop="phone">
			    <el-input v-model="ruleForm.phone"></el-input>
			  </el-form-item>
			  </el-col>
			  <el-col :span="12">
			  <el-form-item label="Company" prop="company" >
			    <el-input v-model="ruleForm.company"></el-input>
			  </el-form-item>
			  </el-col>
			 </el-row>
			 
			 
			 <el-row :gutter="20">
			 			 <el-col :span="24">
			  <el-form-item label="Your Message" prop="message">
			    <el-input type="textarea" v-model="ruleForm.message"></el-input>
			  </el-form-item>
			  </el-col>
		
			 </el-row>
		
		
			
			 <el-row :gutter="20">
			
			 </el-row>
			 
			<div class="h-button" @click="submitForm('ruleForm')">ASK A QUESTION</div>
			 
			 
			  </el-form-item>
			</el-form>
			
		</el-col>
	</el-row>
</div>
	

	
		
		</div>
</div>
  
    </div>
</template>
<script>


export default {

  data() {
    return {

    data:[],
	ruleForm: {
		name:'',
		email:'',     
		phone:'',
		company:'',
		message:''
		
	    
	      },   rules: {
                 	
                 	   name: [
                 	    { required: true, message: 'Please fill in Your Name', trigger: 'blur' },
                 ],email: [
                 	    { required: true, message: 'Please fill in Last Your Email', trigger: 'blur' },
                 ],phone: [
                 	    { required: true, message: 'Please fill in Phone Number', trigger: 'blur' },
                 ],company: [
                 	    { required: true, message: 'Please fill in Company', trigger: 'blur' },
                 ],message: [
                 	    { required: true, message: 'Please fill in Your Message', trigger: 'blur' },
                 ]
                  
                   }

    };
  }, computed:{
	      itemWidth(){  
	            return (138*0.5*(document.documentElement.clientWidth/375)) 
	      },
	      gutterWidth(){
	            return (9*0.5*(document.documentElement.clientWidth/375))	
	      }
	    },
 mounted() {
	  

		this.sandMate();
		this.sandCase();
		},methods: {
		 scroll(scrollData){
		                console.log(scrollData)
		            },
			        switchCol(col){
			            this.col = col
			            console.log(this.col)
			      },
			      loadmore(index){
			            this.data = this.data.concat(this.data)
			      },

			sandMate(){
			
			this.$axios({
			  method: "post",
			  url: "service.php?action=index_newsList",
			  data: {},  
			}).then((res) => {
				let data=res.data;
						
				if(data.code==1){
			
									
					this.data=data.data;
					
					
				}
			 
			});
			
			
			
			},sandCase(){
				this.$axios({
				  method: "post",
				  url: "/api/noticelist",
				  data: {page:1},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==200){
						
						this.notice=data.data;
						
						
					
					}
				 
				});
			},	 submitForm(formName) {
		
			      
		        this.$refs[formName].validate((valid) => {
		          if (valid) {
		         this.$axios({
		           method: "post",
		           url: "service.php?action=users_contactUs",
		           data: this.ruleForm,  
		         }).then((res) => {
		         	let data=res.data;
		         			
		         	if(data.code==1){
						
					this.$message.success(data.message);
					
		         	}else{  
						this.$message.error(data.message);
						      
					}
		          
		         });
				 
				 
		          } else {
		           
		            return false;
		          }
		        });
		      },
		}
};
</script>
<style lang="scss" scoped>
.han-tab{
	margin-top: 20px;
}
.works{

	.pbImgBox img{
		width: 100%;
	}
	.textOver{
		padding: 20px;
	}
	.works-ban{
		padding-top: 30px;
		background: #0A0A0A;
		height: 107px;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		h2{
			font-size: 43px;
		}
		span{
			margin: 20px;
		}
	}
	.works-con{
		margin-top: 20px;
		ul{
			display: flex;
			flex-wrap: wrap;
			li{
				margin: 0 1%;
				width: 23%;
				.pic{
					img{
						width: 100%;
					}
				}
				.txt{
					h6{
						margin: 10px 0;
					}
					p{
						color: #8E8D8D;
					}
				}
			}
		}
		
	}
}
.contact{
	margin-top: 20px;
	.con-buff{
		margin-top: 30px;
		.tit{
			font-size: 24px;
			color: #0A0A0A;
			font-weight: bolder;
			line-height: 50px;
			border-bottom: 1px solid #EAEAEA;
		}
		.con{
			color: #5A5A5A;
			border-bottom: 1px solid #EAEAEA;
			padding: 20px 0;
		}
	}
}
.h-button{
			text-align: center;
			cursor: pointer;
			width: 185px;
			padding: 0 50px;
			height: 50px;
			line-height: 50px;
			background: #D9D9D9;
			color: #0A0A0A;
			margin-top: 30px;
		
		}
		.h-button:hover{
			color: #FFFFFF;
			background-color: #333333;
		}
</style>